import React, { useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../styles/LoginPage.css";
import { AuthContext } from "../components/AuthContext";
import { FiMail, FiLock, FiEye, FiEyeOff } from "react-icons/fi";
import { FcGoogle } from "react-icons/fc";

function LoginPage() {
  //get login function from AuthContext
  const { login, signInWithGoogle } = useContext(AuthContext);
  //State variables to store user input and messages
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  // Function to handle the login form submission
  const handleLogin = async (e) => {
    e.preventDefault(); // Prevent page reload

    console.log("Login-Daten:", { email, password });

    // Ensure both email and password fields are filled
    if (!email || !password) {
      setMessage("Please fill in both email and password");
      return;
    }

    // Call the login function from AuthContext
    const result = await login(email, password);

    if(result.success){
      console.log("Login erfolgreich, weiterleiten...");
      navigate("/"); // Redirect to the home page
    }
    else{
      setMessage(result.message);
    }
  };

  // Google sign-in
  const handleGoogleSignIn = async () => {
    setMessage("");
    const result = await signInWithGoogle();
    if (result.success) {
      navigate('/');
    } else {
      setMessage(result.message || 'Google sign-in failed');
    }
  };

  return (
    <main className="login-container">
      <section className="login-left">
        <p className="welcome-message">Welcome Back!</p>
        <h1 className="login-slogan">
          Log in to <strong className="highlight">clip.board</strong>
        </h1>
      </section>
      <section className="login-right">
        <form className="login-form" onSubmit={handleLogin} aria-label="Login form">
          <p className="form-row">
            <label className="input-group">
              <span className="visually-hidden">Email</span>
              <FiMail className="icon" aria-hidden="true" />
              <input
                id="email"
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
              />
            </label>
          </p>
          <p className="form-row">
            <label className="input-group">
              <span className="visually-hidden">Password</span>
              <FiLock className="icon" aria-hidden="true" />
              <input
                id="password"
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
              />
            </label>
            <button
              type="button"
              className="toggle-visibility"
              aria-label={showPassword ? "Hide password" : "Show password"}
              onClick={() => setShowPassword((v) => !v)}
            >
              {showPassword ? <FiEyeOff /> : <FiEye />}
            </button>
          </p>
          <button className="login2-button" type="submit">Login</button>
          <p className="or-divider" aria-hidden="true">or</p>
          {/* Google sign-in button */}
          <button type="button" className="google-button" onClick={handleGoogleSignIn}>
            <FcGoogle className="google-icon" />
            Continue with Google
          </button>
        </form>
        <p>
          Don't have an account?{" "}
          <Link to="/signup" className="signup-link">Create account</Link>
        </p>
        {message && <p className="message error" role="alert">{message}</p>}
      </section>
    </main>
  );
}

export default LoginPage;
